import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { collection, doc, onSnapshot, query, where } from 'firebase/firestore';
import { store } from '../../../config/firebase';
import { GameStatus } from '../../../constants/gameConstants';
import { liveGameDocs } from '../../../helpers/games';
import GameByStatusCards from '../../ui/gameStatusCards/gameByStatusCards';
import GameLiveCard from '../../ui/gameStatusCards/gameLiveCard';

// Get event
const LiveScoreEvent = () => {
  const { eventId, gameId } = useParams();
  const [game, setGame] = useState({});

  useEffect(() => {
    const gamesRef = collection(store, 'games');
    const q = query(
      gamesRef,
      where('event', '==', eventId.toString()),
      where('live', '==', true),
      where('status', 'in', [GameStatus.IN_PROGRESS, GameStatus.PLAYOFF])
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      console.log(
        'Query Snapshot:',
        querySnapshot.docs.map((doc) => doc.data())
      );
      // Filtered before the index, not after: taking docs[0] of the raw
      // snapshot would let a deleted game be the one shown as live.
      const liveDocs = liveGameDocs(querySnapshot);
      if (liveDocs.length > 0) {
        const firstGame = {
          id: liveDocs[0].id,
          ...liveDocs[0].data()
        };
        setGame(firstGame);
      } else {
        console.log('No games found');
        // If no games match the query, reset the state
        setGame(null);
      }
    });

    return () => unsubscribe(); // Cleanup listener on component unmount
  }, [eventId, gameId]);

  // useEffect(() => {

  //   // Get specific document by ID
  //   const gameRef = doc(store, 'games', gameId);

  //   const unsubscribe = onSnapshot(gameRef, (docSnapshot) => {
  //     console.log('Document Snapshot:', docSnapshot.data());

  //     if (docSnapshot.exists()) {
  //       const gameData = {
  //         id: docSnapshot.id,
  //         ...docSnapshot.data()
  //       };
  //       setGame(gameData);
  //     } else {
  //       console.log('No game found with ID:', gameId);
  //       setGame(null);
  //     }
  //   });

  //   return () => unsubscribe();
  // }, [eventId, gameId]);

  return <Box m={2}>{game && <GameLiveCard game={game} />}</Box>;
};

export default LiveScoreEvent;
